module.exports = __webpack_public_path__ + "static/img/3.437ecc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2/3.png
// module id = oimj
// module chunks = 1